var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"projects",attrs:{"id":"projectspage"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('h2',[_vm._v("I miei Progetti")]),_c('div',{staticClass:"col-lg-4 col-md-4 col-sm-12"},[_c('v-card',[_vm._v(" ARGO STUDIO MUSIC ")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }